import { createSetting } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import { deleteAcsGoods} from '../api'

export const tableSetting = (vm) => createSetting({
  search: [
    { name: '商品名称', key: 'item_name' },
  ],
  columns: [
    { name: '商品ID', key: 'item_id', width: 80 },
    {
      name: '商品',
      key: 'item_name',
      minWidth: 150
    },
    {
      name: '商品类型',
      key: 'goods_type',
      minWidth: 150,
      render: (h, { row }) => {
        return row.goods_type == 'normal' ? '实体赠品' : '虚拟赠品'
      }
    },
    {
      name: '商品金额',
      key: 'price',
      minWidth: 150,
      render: (h, { row }) => {
        return `¥ ${row.price / 100}`
      }
    },
    {
      name: '商品状态',
      key: 'approve_status',
      minWidth: 150,
      render: (h, { row }) => {
        if (row.approve_status == 'onsale') {
          return '前台可销售'
        } else if  (row.approve_status == 'offline_sale') {
          return '可线下销售'
        } else if  (row.approve_status == 'only_show') {
          return '前台仅展示'
        } else if  (row.approve_status == 'instock') {
          return '不可销售'
        }
      }
    }
  ],
  actions: [
    {
      name: '添加',
      slot: 'header',
      type: 'button',
      buttonType: 'primary',
      action: {
        handler: async (rows) => {
          vm.handleGoodsDialogShow()
        }
      }
    },
    {
      name: '批量删除',
      slot: 'header',
      type: 'button',
      buttonType: 'primary',
      action: {
        handler: async (rows) => {
          if(!rows.length) {
            vm.$message.error('请选择要删除的商品')
            return
          }
          MessageBox.confirm('请确认是否批量删除？', '提示').then(async () => {
            const ids = rows.map(v => v.item_id).join(',')
            await deleteAcsGoods(ids)
            vm.$message.success('删除成功')
            vm.refresh()
          })
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          MessageBox.confirm('请确认是否删除当前商品？', '提示').then(async () => {
            const id = rows[0].item_id
            await deleteAcsGoods({ item_id: id }).then(() => {
              vm.$message.success('删除成功')
              vm.refresh()
            })
          })
        }
      }
    },
  ]
})
